<template>
  <MComment v-if="!isEditing" class="work-conversation">
    <!-- <template v-slot:avatar>
      <FlotoUserAvatar
        size="large"
        :disabled="isPortalLogin"
        :user-id="ownerTechnician.id || owner"
      />
    </template> -->
    <template v-slot:content>
      <MRow :gutter="0">
        <MCol
          class="box-container"
          :class="isDraft ? 'border-secondary-red' : conversation.borderClass"
        >
          <MRow
            :gutter="0"
            class="p-2 pr-0 flex justify-between items-center w-full"
          >
            <MCol auto-size class="flex items-center">
              <FlotoUserAvatar
                size="small"
                :disabled="isPortalLogin"
                :user-id="ownerTechnician.id || owner"
              />
              <FlotoUserDrawer
                :user-id="owner"
                v-bind="{
                  ...(type === 'requestor_to_technician'
                    ? { userId: owner }
                    : {
                        user: ownerTechnician,
                      }),
                }"
                :disabled="isPortalLogin"
              />
            </MCol>
            <MCol auto-size class="flex items-center">
              <MCol
                auto-size
                :class="conversation.textClass"
                class="flex items-center"
              >
                <div v-if="isDraft" class="draft-text">
                  {{ `[${$tc('draft')}]` }}
                </div>
                <div class="text-neutral">
                  <small>
                    {{ createdAt | datetime }} ({{ createdAt | timeago }})
                  </small>
                </div>
                <!-- Conversation Pills using div -->
                <div class="conversation-pills mr-2">
                  <div
                    class="pill"
                    :class="{
                      [conversation.textClass]: true,
                      [conversation.activeBgClass]: true,
                    }"
                    :style="currentStyle"
                  >
                    {{ toolTipText }}
                  </div>
                </div>
                <a
                  v-if="!disabled && canEdit"
                  href="javascript:;"
                  class="text-neutral mr-1"
                  @click="handleEdit"
                >
                  <MTooltip>
                    <template v-slot:trigger>
                      <MButton
                        variant="default"
                        class="button-neutral-lighter rounded p-0"
                      >
                        <MIcon name="pencil" class="text-light p-1" size="lg" />
                      </MButton>
                    </template>
                    {{ $t('edit') }}
                  </MTooltip>
                </a>
                <FlotoDeleteBtn
                  v-if="canDeleteReview || canDeleteNote"
                  :message="$t('confirm_remove_item', { item: toolTipText })"
                  class="mr-1"
                  :border="false"
                  only-icon
                  :size="'lg'"
                  @confirm="$emit('delete')"
                />
              </MCol>
            </MCol>
          </MRow>
          <MDivider />
          <!-- <MTooltip v-if="isPrivate && usePrivateIndicator">
            <template v-slot:trigger>
              <MIcon
                name="lock-alt"
                class="mr-2 text-neutral absolute"
                :style="
                  isRtl
                    ? { top: '15px', right: '0px' }
                    : { top: '15px', left: '4px' }
                "
              />
            </template>
            {{ $t('not_visible_to_requester') }}
          </MTooltip> -->
          <template v-if="conversation.type === 'feedback'">
            <Feedback v-bind="{ feedback: $props }" />
          </template>
          <template v-else>
            <MCol class="editor-row">
              <MRow :gutter="0" class="flex-no-wrap items-start">
                <MCol class="mr-2">
                  <template
                    v-if="
                      [
                        'forward_notification',
                        'technician_to_requester',
                        'requestor_to_technician',
                      ].indexOf(conversation.type) >= 0
                    "
                  >
                    <div class="flex flex-col gap-2">
                      <small
                        class="font-500 flex items-center justify-between"
                        :class="emailIds.length > 0 ? '' : 'mb-2'"
                      >
                        <h6>
                          {{ subject }}
                        </h6>
                        <span class="flex items-center">
                          <MTooltip
                            v-if="
                              [
                                'technician_to_requester',
                                'requestor_to_technician',
                                'forward_notification',
                                'other_user_to_requster',
                              ].indexOf(type) >= 0 &&
                              !isPortalLogin &&
                              !isDraft
                            "
                          >
                            <template v-slot:trigger>
                              <MIcon
                                name="reply"
                                class="cursor-pointer text-light"
                                size="lg"
                                @click="
                                  $emit('reply', {
                                    text,
                                    attachments,
                                    createdAt,
                                    owner,
                                    emailIds,
                                    ccEmailIds,
                                  })
                                "
                              />
                            </template>
                            {{ $t('reply') }}
                          </MTooltip>
                          <MTooltip
                            v-if="
                              [
                                'technician_to_requester',
                                'requestor_to_technician',
                                'forward_notification',
                                'other_user_to_requster',
                              ].indexOf(type) >= 0 &&
                              !isPortalLogin &&
                              !isDraft
                            "
                          >
                            <template v-slot:trigger>
                              <MIcon
                                name="share"
                                class="cursor-pointer text-light ml-2"
                                size="lg"
                                @click="
                                  $emit('forward', {
                                    text,
                                    attachments,
                                    createdAt,
                                    owner,
                                  })
                                "
                              />
                            </template>
                            {{ $t('forward') }}
                          </MTooltip>
                        </span>
                      </small>
                      <FlotoFormItemReadOnly
                        v-if="(emailIds || []).length > 0"
                        class="mb-1"
                      >
                        <small class="flex items-center pt-1">
                          {{ $t('to') }} :
                          <FlotoTagsPicker
                            :value="emailIds"
                            disabled
                            type="email"
                          />
                        </small>
                      </FlotoFormItemReadOnly>
                      <FlotoFormItemReadOnly
                        v-if="(ccEmailIds || []).length > 0"
                        class="mb-1"
                      >
                        <small class="flex items-center">
                          {{ $t('cc') }} :
                          <FlotoTagsPicker
                            :value="ccEmailIds"
                            disabled
                            type="email"
                          />
                        </small>
                      </FlotoFormItemReadOnly>
                      <MDivider />
                    </div>
                  </template>
                  <div class="flex flex-col">
                    <FlotoReadMore :height="richBoxRows * 20">
                      <FlotoRichEditor
                        :value="latestText"
                        :disabled="true"
                        :enable-mention="true"
                        class="flex-1 border-none mb-1"
                      />
                    </FlotoReadMore>
                  </div>
                  <div v-if="trailText" class="flex flex-col">
                    <FlotoAnchorLink
                      :aria-label="
                        $t(
                          trailExpanded
                            ? 'hide_expanded_content'
                            : 'show_trimmed_content'
                        )
                      "
                      @click="toggleTrail"
                    >
                      <MTooltip>
                        <template v-slot:trigger>
                          <MIcon name="ellipsis-h" size="3x" />
                        </template>
                        {{
                          $t(
                            trailExpanded
                              ? 'hide_expanded_content'
                              : 'show_trimmed_content'
                          )
                        }}
                      </MTooltip>
                    </FlotoAnchorLink>
                    <div v-if="trailExpanded" class="trail-text">
                      <FlotoRichEditor
                        :value="trailText"
                        :disabled="true"
                        :enable-mention="true"
                        class="flex-1 border-none mb-1"
                      />
                    </div>
                  </div>
                </MCol>
              </MRow>
            </MCol>
          </template>

          <MCol v-if="attachments.length > 0" class="mb-2">
            <div class="px-2 border-top">
              <FlotoAttachment v-model="attachments" disabled />
            </div>
          </MCol>
        </MCol>
      </MRow>
    </template>
  </MComment>
  <AddBox
    v-else
    :id="id"
    :processing="processing"
    :conversation-type="conversation"
    :resource="resource"
    :allow-save-in-draft="conversation.type !== 'note' && allowSaveInDraft"
    v-bind="formData"
    :is-private="isPrivate && usePrivateIndicator"
    :allow-templates="allowTemplates"
    :allow-subject="allowSubject"
    :allow-email="allowEmail"
    :allow-cc-email="allowCcEmail"
    :allow-outgoing-email="allowOutgoingEmail"
    :default-email-send-config-id="defaultEmailSendConfigId"
    :module-name="moduleName"
    :allow-knowledges="allowKnowledges"
    :form-data="{ subject, emailIds, ccEmailIds }"
    :is-draft="isDraft"
    @submit="updateConversation"
    @remove="resetConversation"
  >
    <template v-slot:editor-actions>
      <div class="floating-actions">
        <MTooltip v-if="isAddingPrivateConversation">
          <template v-slot:trigger>
            <MButton
              variant="default"
              class="button-neutral-lighter rounded p-0"
            >
              <MIcon name="lock-alt" size="lg" class="text-light p-1" />
            </MButton>
          </template>
          {{ $t('not_visible_to_requester') }}
        </MTooltip>
        <MTooltip>
          <template v-slot:trigger>
            <MButton
              variant="default"
              class="button-neutral-lighter rounded p-0"
              @click.stop="handleClose"
            >
              <MIcon name="times" size="lg" class="text-light p-1" />
            </MButton>
          </template>
          {{ $t('cancel') }}
        </MTooltip>
      </div>
    </template>
  </AddBox>
</template>

<script>
import { authComputed } from '@state/modules/auth'
import { PreferenceComputed } from '@state/modules/preference'
import { TechnicianComputed } from '@state/modules/technician'
import { ConversationType } from './conversation-types'
import AddBox from './conversation-add-box'
import Feedback from './feedback'
import { getTagStyleFromColor } from '@/src/utils/color'
export default {
  name: 'Conversation',
  components: { AddBox, Feedback },
  props: {
    id: { type: Number, default: undefined },
    update: { type: Function, default: undefined },
    type: { type: String, required: true },
    text: { type: [String], default: undefined },
    attachments: { type: Array, required: true },
    rating: { type: Number, default: 0 },
    fieldValueDetails: {
      type: Object,
      default() {
        return {}
      },
    },
    subject: { type: [String], default: undefined },
    emailIds: {
      type: Array,
      default() {
        return []
      },
    },
    ccEmailIds: {
      type: Array,
      default() {
        return []
      },
    },
    createdAt: { type: Number, required: true },
    owner: { type: Number, default: undefined },
    canEdit: { type: Boolean, default: false },
    canDelete: { type: Boolean, default: false },
    isPrivate: { type: Boolean, default: false },
    inlineEdit: { type: Boolean, default: false },
    usePrivateIndicator: { type: Boolean, required: true },
    disabled: { type: Boolean, default: false },
    richBoxRows: { type: Number, default: 8 },
    resource: {
      type: Object,
      default() {
        return {}
      },
    },
    allowSaveInDraft: { type: Boolean, default: false },
    isDraft: { type: Boolean, default: false },
    allowKnowledges: { type: Boolean, default: false },
    allowTemplates: { type: Boolean, default: false },
    moduleName: { type: String, default: undefined },
    defaultEmailSendConfigId: { type: Number, default: 0 },
    // eslint-disable-next-line
    isDeletable: { type: Boolean, default: true },
  },
  data() {
    return {
      processing: false,
      isEditing: false,
      formData: {},
      trailExpanded: false,
    }
  },
  computed: {
    ...authComputed,
    ...TechnicianComputed,
    ...PreferenceComputed,
    conversation() {
      return ConversationType()[this.type] || {}
    },
    toolTipText() {
      if (this.isPortalLogin && this.type === 'technician_to_requester') {
        return this.$t('reply_from_technician')
      }
      if (!this.isPortalLogin && this.type === 'requestor_to_technician') {
        return this.$t('reply_from_requester')
      }
      return this.conversation.name
    },
    ownerTechnician() {
      return this.technician(this.owner)
    },
    allowSubject() {
      if (
        ['forward_notification', 'other_user_to_requster'].indexOf(
          this.conversation.type
        ) >= 0
      ) {
        return true
      }
      return false
    },
    allowEmail() {
      if (
        [
          'forward_notification',
          'other_user_to_requster',
          'technician_to_requester',
        ].indexOf(this.conversation.type) >= 0
      ) {
        return true
      }
      return false
    },
    allowCcEmail() {
      if (
        [
          'forward_notification',
          'other_user_to_requster',
          'technician_to_requester',
        ].indexOf(this.conversation.type) >= 0
      ) {
        return true
      }
      return false
    },
    allowOutgoingEmail() {
      if (
        [
          'forward_notification',
          'other_user_to_requster',
          'technician_to_requester',
        ].indexOf(this.conversation.type) >= 0
      ) {
        return true
      }
      return false
    },
    canDeleteNote() {
      if (!this.isDeletable && this.conversation.type === 'note') {
        return !this.disabled && this.canDelete
      }
      return !this.disabled && this.canDelete && this.isDeletable
    },
    canDeleteReview() {
      if (this.conversation.type === 'review') {
        return (
          (!this.disabled && this.canDelete) ||
          this.myAllowedModules.indexOf('knowledge.can_manage_review') >= 0
        )
      }
      return !this.disabled && this.canDelete && this.isDeletable
    },
    latestText() {
      const regEx = /<hr(?:[^>]*)\/?>/
      const arr = this.text.split(regEx)
      const filteredArr = arr.filter((e) => e)
      if (filteredArr.length > 1) {
        return arr[0]
      }
      return this.text
    },
    trailText() {
      const regEx = /<hr(?:[^>]*)\/?>/
      const arr = this.text.split(regEx)
      const filteredArr = arr.filter((e) => e)
      if (filteredArr.length > 1) {
        arr.shift()
        return arr.join('')
      }
      return ''
    },
    currentStyle() {
      let cssVarName = this.conversation.activeBgClass.replace('bg-', '')

      // Special case for neutral
      if (cssVarName === 'neutral') {
        cssVarName = 'neutral-darker'
      } else {
        cssVarName = cssVarName
          .replace(/([a-z])([A-Z])(ark|ight)/g, '$1-$2$3')
          .replace(/([a-z])([A-Z])/g, '$1-$2')
          .toLowerCase()
      }

      const bgColor = getComputedStyle(
        document.documentElement
      ).getPropertyValue(`--${cssVarName}`)
      return getTagStyleFromColor(bgColor, this.theme)
    },
  },
  methods: {
    toggleTrail() {
      this.trailExpanded = !this.trailExpanded
    },
    handleEdit() {
      if (this.inlineEdit) {
        this.formData = {
          value: this.text,
          fileAttachments: this.attachments.map((a) => a),
          ...(this.allowSubject ? { subject: this.subject } : {}),
          ...(this.allowEmail ? { emailIds: this.emailIds } : {}),
          ...(this.allowCcEmail ? { ccEmailIds: this.ccEmailIds } : {}),
          ...(this.allowOutgoingEmail
            ? { emailSendConfigId: this.emailSendConfigId }
            : {}),
        }
        this.isEditing = true
      } else {
        this.$emit('edit')
      }
    },
    updateConversation(conversation) {
      if (!this.update) {
        throw new Error('update function not found for conversation')
      }
      this.processing = true
      this.update(conversation)
        .then((response) => {
          this.isEditing = false
          return response
        })
        .finally(() => {
          this.processing = false
        })
    },
    handleClose() {
      this.isEditing = false
      this.formData = {}
      this.$emit('remove')
    },
    resetConversation() {
      this.formData = {}
      this.isEditing = false
    },
  },
}
</script>

<style lang="less" scoped>
.work-conversation {
  .@{ant-prefix}-comment-content {
    padding: 0;
  }
}

.box-container {
  @apply border-solid border rounded  px-6;

  border-color: var(--border-color);

  .editor-row {
    @apply p-2;
  }
  .@{ant-prefix}-divider {
    margin: 0 !important;
  }
}

.draft-text {
  margin-right: 10px;
  color: var(--secondary-red);
}

i.info-icon {
  position: absolute;
  top: -26px;
  right: -19px;
  padding: 4px;
  font-size: 9px;
  background: var(--page-background-color);
  border: 1px solid var(--border-color);
  border-radius: 50%;
}

.trail-text {
  padding-left: 2px;
  border-left: 1px solid var(--border-color);
}

.conversation-pills {
  display: flex;
  gap: 8px;
  align-items: center;
}

.pill {
  padding: 4px 12px;
  margin-left: 10px;
  font-size: 12px;
  color: var(--text-color);
  border-radius: 4px;

  &:hover {
    opacity: 0.8;
  }
}

.floating-actions {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  display: flex;
  gap: 0;
  padding: 4px;
}
</style>
